import React from 'react';
import { ReactComponent as CheckCircle } from 'src/Images/icons/common/check-circle.svg';
import { ReactComponent as ErrorSyncCircle } from 'src/Images/icons/common/error-sync-circle.svg';
function EventSyncLogTableContent({ headers, syncLogs }) {
  return (
    <tbody>
      {syncLogs && syncLogs.length > 0 ? (
        syncLogs.map((log) => (
          <tr key={log.id}>
            {headers.map((header) => (
              <td className="table-data" key={`${log.id}-${header.value}`}>
                <div className="div-flex-row">
                  {header.value === 'status' ? (
                    log[header.value].toLowerCase() === 'success' ? (
                      <div className="text-success">
                        <CheckCircle className="icon-size-sm" />
                        <span className="text-sm"> Synced</span>
                      </div>
                    ) : log[header.value].toLowerCase() === 'error' ? (
                      <div className="text-danger">
                        <ErrorSyncCircle className="icon-size-lg" />
                        <span className="text-sm"> Failed</span>
                      </div>
                    ) : null
                  ) : header.value === 'resolved' ? (
                    <div className="text-success">
                      {log[header.value] ? (
                        <div className="text-success">
                          <span className="text-sm"> resolved</span>
                        </div>
                      ) : (
                        <div className="text-danger">
                          <span className="text-sm"> unresolved</span>
                        </div>
                      )}
                    </div>
                  ) : header.value === 'timestamp' ? (
                    <span>{log[header.value]}</span>
                  ) : (
                    <span>{log[header.value]}</span>
                  )}
                </div>
              </td>
            ))}
          </tr>
        ))
      ) : (
        <div className="no-data-found-message border-bottom">
          <span className="text-sm">No sync logs found</span>
        </div>
      )}
    </tbody>
  );
}

export default EventSyncLogTableContent;
